const setMultipleFilters = (reviews, userSlug) => {
  const queryParams = {};

  if (userSlug) {
    queryParams.q = { user_slug_eq: userSlug };
  }
  if (reviews?.quickFilters?.length) {
    queryParams.quick_filter = reviews.quickFilters;
  }
  if (reviews?.search) {
    queryParams.keyword = reviews.search;
  }
  if (reviews?.advancedFilters) {
    queryParams.q = {
      ...queryParams.q,
      ...reviews.advancedFilters,
    };
  }

  return queryParams;
};

const setSingleFilter = (reviews, userSlug) => {
  const queryParams = {};

  if (userSlug) {
    queryParams.q = { user_slug_eq: userSlug };
  } else if (reviews?.quickFilters?.length) {
    queryParams.quick_filter = reviews.quickFilters;
  } else if (reviews?.search) {
    queryParams.keyword = reviews.search;
  } else if (reviews?.advancedFilters) {
    queryParams.q = reviews.advancedFilters;
  }

  return queryParams;
};

export const buildQueryParams = (reviews, userSlug, addMultipleParams) => {
  if (addMultipleParams) {
    return setMultipleFilters(reviews, userSlug);
  } else {
    return setSingleFilter(reviews, userSlug);
  }
};
